import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition,
    PropertyMappingType,
} from "app/library/layout-builder";
import { PopupAnnouncementProps } from "./types";

export class PopupAnnouncementDefinitions extends CmsReactComponent<PopupAnnouncementProps> {
    static defaultProps = {};

    static schemaName = "popup-announcement";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "title",
            text: "Başlık",
            mapping: {
                type: PropertyMappingType.String,
            }
        },
        {
            name: "content",
            text: "İçerik",
            mapping: {
                type: PropertyMappingType.Html,
            }
        },
    ];
}
